module.exports = __webpack_public_path__ + "media/images/emblems/Triengen_LU-cb322435de38fac64b690ea7aaa66269.png";